import React, { Fragment } from 'react';
import { isString, isNumber } from 'lodash';

export const isStringOrNumber = (value) => isString(value) || isNumber(value);

export const getHiddenCrumbComponent = (list, hiddenCrumbsLength) => {
  const children = list
    .slice(1, hiddenCrumbsLength + 1)
    .map((crumbObject, index) => crumbObject.tooltipTitle && <div key={`more-crumb-${index}`}>{crumbObject.tooltipTitle}</div>);

  const tooltipTitle = <Fragment children={children} />;

  return { children: '...', tooltipTitle, className: 'more-crumb', forceTooltip: true, disabled: true };
};
